export default "__VITE_PUBLIC_ASSET__c8c86f08__"